import React from 'react';
import { injectIntl } from 'react-intl';
import { TextInput, PublishedComponent, formatMessage } from '@stssocialst-stp/fe-core';
import { FormControlLabel, Grid, Checkbox } from '@material-ui/core';
import { withTheme, withStyles } from '@material-ui/core/styles';
import _debounce from 'lodash/debounce';
import { CONTAINS_LOOKUP, DEFAULT_DEBOUNCE_TIME, EMPTY_STRING } from '../constants';
import { defaultFilterStyles } from '../util/styles';
import BeneficiaryStatusPicker from '../pickers/BeneficiaryStatusPicker';
import BenefitPlanTypePicker from '../pickers/BenefitPlanTypePicker';

function BenefitPlanFilter({
  intl, classes, filters, onChangeFilters, showStatuses,
}) {
  const debouncedOnChangeFilters = _debounce(onChangeFilters, DEFAULT_DEBOUNCE_TIME);

  const filterValue = (filterName) => filters?.[filterName]?.value;

  const filterTextFieldValue = (filterName) => filters?.[filterName]?.value ?? EMPTY_STRING;

  const onChangeStringFilter = (filterName, lookup = null) => (value) => {
    if (lookup) {
      debouncedOnChangeFilters([
        {
          id: filterName,
          value,
          filter: `${filterName}_${lookup}: "${value}"`,
        },
      ]);
    } else {
      onChangeFilters([
        {
          id: filterName,
          value,
          filter: `${filterName}: "${value}"`,
        },
      ]);
    }
  };

  const onChangeCheckbox = (key, value) => {
    const filters = [
      {
        id: key,
        value,
        filter: `${key}: ${value}`,
      },
    ];
    onChangeFilters(filters);
  };

  return (
    <Grid container className={classes.form}>
      <Grid item xs={2} className={classes.item}>
        <TextInput
          module="socialProtection"
          label="benefitPlan.code"
          value={filterTextFieldValue('code')}
          onChange={onChangeStringFilter('code', CONTAINS_LOOKUP)}
        />
      </Grid>
      <Grid item xs={2} className={classes.item}>
        <TextInput
          module="socialProtection"
          label="benefitPlan.name"
          value={filterTextFieldValue('name')}
          onChange={onChangeStringFilter('name', CONTAINS_LOOKUP)}
        />
      </Grid>
      <Grid item xs={3} className={classes.item}>
        <BenefitPlanTypePicker
          module="socialProtection"
          label="beneficiary.benefitPlanTypePicker"
          value={filterValue('type')}
          onChange={(v) => onChangeFilters([
            {
              id: 'type',
              value: v,
              filter: `type: ${v}`,
            },
          ])}
          withNull={false}
        />
      </Grid>
      <Grid item xs={2} className={classes.item}>
        <PublishedComponent
          pubRef="core.DatePicker"
          module="socialProtection"
          label="benefitPlan.dateValidFrom"
          value={filterValue('dateValidFrom')}
          onChange={(v) => onChangeFilters([
            {
              id: 'dateValidFrom',
              value: v,
              filter: `dateValidFrom: "${v}T00:00:00.000Z"`,
            },
          ])}
        />
      </Grid>
      <Grid item xs={2} className={classes.item}>
        <PublishedComponent
          pubRef="core.DatePicker"
          module="socialProtection"
          label="benefitPlan.dateValidTo"
          value={filterValue('dateValidTo')}
          onChange={(v) => onChangeFilters([
            {
              id: 'dateValidTo',
              value: v,
              filter: `dateValidTo: "${v}T00:00:00.000Z"`,
            },
          ])}
        />
      </Grid>
      <Grid item xs={2} className={classes.item}>
        <FormControlLabel
          control={(
            <Checkbox
              color="primary"
              checked={filterValue('isDeleted')}
              onChange={(event) => onChangeCheckbox(
                'isDeleted',
                event.target.checked,
              )}
            />
          )}
          label={formatMessage(intl, 'socialProtection', 'benefitPlan.isDeleted')}
        />
      </Grid>
      {showStatuses && (
        <Grid item xs={2} className={classes.item}>
          <BeneficiaryStatusPicker
            label="beneficiary.beneficiaryStatusPicker"
            withNull
            nullLabel={formatMessage(intl, 'socialProtection', 'any')}
            value={filterValue('beneficiaryStatus')}
            onChange={(value) => onChangeFilters([
              {
                id: 'beneficiaryStatus',
                value,
                filter: `beneficiaryStatus: "${value}"`,
              },
            ])}
          />
        </Grid>
      )}
    </Grid>
  );
}

export default injectIntl(withTheme(withStyles(defaultFilterStyles)(BenefitPlanFilter)));
